module.exports = __webpack_public_path__ + "media/images/lb/296-482a46a793152eef4a06a8cbb95857d9.svg";